export class AreaP2WebModel {
  public type_module: any[] = [];
  public cdc: string;
  public notes: string;
}
